import { Backdrop, Box, Button, CircularProgress, Snackbar, Stack, TextareaAutosize, Typography } from '@mui/material'
import React from 'react'
import styles from '../../styles/modal/modalwrappermd.module.scss'
// import Image from 'next/image'
import assest from '../../json/assest'

const ContentbuyerVideotypeModal = () => {
    const [snackOpen, setSnackOpen] = React.useState(false);

    const handleClick = () => {
        setSnackOpen(true);
    };

    const handleClose = (
        event,
        reason
    ) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackOpen(false);
    };
    return (
        <>
            <Box className={styles.videotypeModalwrapper}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'} className={styles.typeModalHeader}>
                    <Typography variant='h6'>Leave a note for the team</Typography>
                    <Typography variant='body1' className={styles.hedaerDate}><span>Date:</span> January 25, 2023 at 09:21 PM UTC</Typography>
                </Stack>
                <Box className={styles.typeModalBody}>
                    <Typography variant='overline'>Is there something you would like to bring to the team's attention?</Typography>
                    <TextareaAutosize />
                    <Box className="attachFileinput">
                        <input type="file" id="upload" hidden />
                        <label htmlFor="upload"><img src={assest.attachIcon} width={13} height={15} alt='' /> Attach a file</label>
                    </Box>
                </Box>
                <Box className={styles.typeModalFooter}>
                    <Button>Cancel</Button>
                    <Button className={styles.btnSave} onClick={handleClick}>Save <strong>Now</strong></Button>
                </Box>
            </Box>

            <Backdrop
                open={snackOpen}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleClose}
            >
                <Snackbar
                    open={snackOpen}
                    autoHideDuration={100000}
                    onClose={handleClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span>
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 0 0 65px",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                }
                            },
                        },
                    }}
                />
            </Backdrop>
        </>
    )
}

export default ContentbuyerVideotypeModal